import Vue from "vue";
import VueRouter from "vue-router";
import Mam from "@/views/Mam.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Mam", component: Mam },
];

const router = new VueRouter({ routes });

export default router;
